/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/
type DateValue = Date | number | string | null | undefined;
const pad = (value: number): string => String(value).padStart(2, "0");
function date(value: DateValue): Date | null {
  if (value === null || value === undefined || value === "") return null;
  const result = value instanceof Date ? value : new Date(value);
  return Number.isNaN(result.getTime()) ? null : result;
}
/** Keep local time zones, but use one numeric display format in every UI language. */
export function formatRecordingDate(value: DateValue): string {
  const d = date(value);
  return d
    ? `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${String(d.getFullYear()).padStart(4, "0")}`
    : "—";
}
export function formatRecordingTime(value: DateValue): string {
  const d = date(value);
  return d ? `${pad(d.getHours())}:${pad(d.getMinutes())}` : "—";
}
export function formatRecordingDateTime(value: DateValue): string {
  return date(value)
    ? `${formatRecordingDate(value)} ${formatRecordingTime(value)}`
    : "—";
}

/** Date filter values use the same local calendar day as the visible recording date. */
export function recordingDateKey(value: DateValue): string {
  const d = date(value);
  return d
    ? `${String(d.getFullYear()).padStart(4, "0")}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    : "";
}
